/*=============================
=       Lazy Load Images      =
=============================*/

document.addEventListener('DOMContentLoaded', function() {
	var heroImages = [].slice.call(document.querySelectorAll('#hero .bg-container')),
		lazyImages = [].slice.call(document.querySelectorAll('main img:not(.not-lazy), main .bg-container:not(.first), footer img')),
		active = false,
		heroLazyLoad = function() {
			heroImages.forEach(function(img) {
				bgLazyLoad(img);

				heroImages = heroImages.filter(function(image) {
					return image !== img;
				});

				if(heroImages.length === 0) {
					document.removeEventListener('scroll', heroLazyLoad);
					window.removeEventListener('resize', heroLazyLoad);
					window.removeEventListener('orientationchange', heroLazyLoad);
				}
			});
		};

	// Hero Images
	setTimeout(heroLazyLoad, 1);

	// Regular Images
	var lazyLoad = function() {
		if(active === false) {
			active = true;

			setTimeout(function() {
				lazyImages.forEach(function(img) {
					if((img.getBoundingClientRect().top <= (window.innerHeight + 300) && img.getBoundingClientRect().bottom >= 0) && getComputedStyle(img).display !== 'none') {
						if(img.classList.contains('bg-container') && img.tagName != 'IMG')
							bgLazyLoad(img);
						else
							imgLazyload(img);

						lazyImages = lazyImages.filter(function(image) {
							return image !== img;
						});

						if(lazyImages.length === 0) {
							document.removeEventListener('scroll', lazyLoad);
							window.removeEventListener('resize', lazyLoad);
							window.removeEventListener('orientationchange', lazyLoad);
						}
					}
				});

				active = false;
			}, 200);
		}
	};

	document.addEventListener('scroll', lazyLoad);
	window.addEventListener('resize', heroLazyLoad);
	window.addEventListener('resize', lazyLoad);
	window.addEventListener('orientationchange', heroLazyLoad);
	window.addEventListener('orientationchange', lazyLoad);
});

function imgLazyload(img) {
	img.src = img.dataset.src;
	img.classList.add('loaded');
}

function bgLazyLoad(img) {
	img.style.backgroundImage = 'url('+img.getAttribute('data-src'+(checkWidth(768) && img.hasAttribute('data-src-mobile') ? '-mobile' : ''))+')';

	setTimeout(function() {
		img.classList.add('loaded');
	}, 300);
}

/*=============================
=         Sticky Header       =
=============================*/

var stickyHeader = new Waypoint({
	element: main,
	handler: function(direction) {
		var down = direction == 'down';

		if(down)
			body.classList.add('sticky');
		else
			body.classList.remove('sticky');
	},
	offset: header.offsetHeight
});

var lastScrollTop = 0;

window.addEventListener('scroll', function() {
	if(checkWidth(480) && body.classList.contains('sticky') && topbar) {
		var st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > lastScrollTop)
			topbar.classList.add('hide');
		else
			topbar.classList.remove('hide');

		lastScrollTop = st <= 0 ? 0 : st;
	}
});

/*=============================
=        Announcements        =
=============================*/

var announcements = document.querySelectorAll('#announcements .announcement'),
	multipleAnnouncements = announcements.length > 1,
	announcementHeight = multipleAnnouncements ? announcements[0].offsetHeight : 0;

if(multipleAnnouncements) {
	var autoSlideAnnouncements = function() {
			slideAnnouncement();
		},
		announcementsIntervalID = setInterval(autoSlideAnnouncements, 15000);

	setTopbarHeight(true);

	[].slice.call(topbar.querySelectorAll('.controller button')).forEach(function(button) {
		button.addEventListener('click', function() {
			clearInterval(announcementsIntervalID);

			if(this.classList.contains('next')) {
				slideAnnouncement();

				if(this.previousSibling.classList.contains('pause'))
					announcementsIntervalID = setInterval(autoSlideAnnouncements, 15000);
			}
			else {
				var isPlay = this.classList.contains('play');

				if(isPlay)
					announcementsIntervalID = setInterval(autoSlideAnnouncements, 15000);

				this.className = isPlay ? 'pause' : 'play';
				this.setAttribute('aria-label', (isPlay ? 'Pause' : 'Play')+' Announcements');
			}
		});
	});
}

function setTopbarHeight(resize) {
	var newAnnouncementHeight = document.querySelector('#announcements .announcement.current').offsetHeight;

	if(resize || (!resize && newAnnouncementHeight > announcementHeight)) {
		topbar.removeAttribute('style');

		topbar.style.height = topbar.offsetHeight+'px';

		announcementHeight = newAnnouncementHeight;
	}
}

function slideAnnouncement() {
	var current = document.querySelector('#announcements .current'),
		sibling = current == announcements[announcements.length-1] ? announcements[0] : current.nextSibling;

	current.classList.add('hide');

	setTimeout(function() {
		current.classList.remove('current', 'next', 'hide');
		sibling.classList.add('current', 'next');
		setTopbarHeight(false);
	}, 550);
}

window.addEventListener('resize', function() {
	if(multipleAnnouncements)
		setTopbarHeight(true);
});

/*=============================
=             Menu            =
=============================*/

var menu = document.getElementById('menu'),
	mobileMenu = document.getElementById('menu-container'),
	mobileMenuButton = document.getElementById('mobile-menu-button');

body.addEventListener('click', function(e) {
	checkAndCloseMenu(e.target);
});

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		checkAndCloseMenu(menu);
});

function checkAndCloseMenu(e) {
	var open = openMenu(e);

	if(open) {
		closeMenu(open);
		toggleMenuBodyClass(false);
	}
}

[].slice.call(header.querySelectorAll('button:not([type="submit"])')).forEach(function(navLink) {
	if(!navLink.parentNode.classList.contains('controller'))
		navLink.addEventListener('click', toggleMenu);
});

function toggleMenu() {
	closeMenu(openMenu(this));

	var isMobileMenu = this == mobileMenuButton,
		isCloseSubmenu = this.classList.contains('close-submenu'),
		topButton = isCloseSubmenu ? this.parentNode.previousElementSibling : this,
		sibling = isMobileMenu ? mobileMenu : topButton.nextElementSibling,
		// parent = this.parentNode.parentNode,
		// openSibling = parent.querySelector('.open'),
		isOpen = topButton.classList.contains('open');

	// if(parent.classList.contains('submenu') && openSibling && openSibling != this)
	// 	closeMenu(openSibling);

	// Velocity(this.nextElementSibling, (this.classList.contains('open') ? 'slideUp' : 'slideDown'), {duration: this == mobileMenuButton ? 300 : 150});

	if(checkWidth(1200) && sibling.classList.contains('submenu')) {
		Velocity(sibling, {left: isOpen ? ['100%',0] : [0,'100%']}, {duration: 500, display: isOpen ? 'none' : 'block'});

		setTimeout(function() {
			sibling.classList.toggle('showing');
		}, isOpen ? 0 : 500);
	}
	else
		Velocity(sibling, {opacity: isOpen ? [0,1] : [1,0]}, {duration: 300, display: isOpen ? 'none' : (isMobileMenu ? 'flex' : 'block')});

	topButton.classList.toggle('open');

	topButton.setAttribute('aria-expanded', (topButton.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

	if(!isCloseSubmenu)
		toggleMenuBodyClass(header.querySelector('button:not([type="submit"]).open'));
}

function closeMenu(el) {
	if(el) {
		var submenu = el == mobileMenuButton ? mobileMenu : el.nextElementSibling;

		if(checkWidth(1200) && submenu.classList.contains('submenu')) {
			Velocity(submenu, {left: ['100%',0]}, {duration: 500, display: 'none'});

			setTimeout(function() {
				submenu.classList.remove('showing');
			}, 0);
		}
		else
			// Velocity(submenu, 'slideUp', {duration: el == mobileMenuButton ? 300 : 150});
			Velocity(submenu, {opacity: [0,1]}, {duration: 300, display: 'none'});

		el.classList.remove('open');

		// closeMenu(submenu.querySelector('.open'));
	}
}

function openMenu(el) {
	var openButton = header.querySelector('button:not([type="submit"]).open');

	if(openButton && openButton == mobileMenuButton)
		return mobileMenu.contains(el) ? false : (el != mobileMenuButton && !mobileMenuButton.contains(el) ? openButton : false);

	return openButton && !openButton.parentNode.contains(el) && !el.classList.contains('close-submenu') ? openButton : false;
}

function toggleMenuBodyClass(open) {
	if(open)
		body.classList.add('menu-open');
	else
		body.classList.remove('menu-open');

	setFocus((open ? true : false), header);
}

function setFocus(open, container) {
	[].slice.call(document.querySelectorAll('#header, #hero, #main, #footer')).forEach(function(parent) {
		if(parent != container) {
			parent.setAttribute('aria-hidden', open);

			[].slice.call(parent.querySelectorAll('a, button, input')).forEach(function(link) {
				if(open)
					link.setAttribute('tabindex', '-1');
				else
					link.removeAttribute('tabindex');
			});
		}
	});
}

/*=============================
=        Skip to Content      =
=============================*/

var skipLink = document.getElementById('skip-link');

skipLink.addEventListener('click', function(e) {
	e.preventDefault();

	var firstLink = document.querySelector('#hero a, main a');

	if(firstLink) {
		scrollToElement(firstLink);
		firstLink.focus();
	}
});

function skipLinkToggleDisplay(hide) {
	skipLink.style.display = hide ? 'none' : '';
}

/*=============================
=            Sidebar          =
=============================*/

var sidebar = document.getElementById('sidebar');

[].slice.call(document.querySelectorAll('.section-id')).forEach(function(section) {
	var sectionWaypointDown = new Waypoint({
		element: section,
		handler: function(direction) {
			var currentSection = direction == 'down' ? section : getPreviousSection(section);

			if(currentSection)
				setSidebar(sidebar.querySelector('a[href="#'+currentSection.id+'"]'));
		},
		offset: '50%'
	});
});

function getPreviousSection(section) {
	var sibling = section.previousElementSibling;

	while(sibling) {
		if(sibling.classList.contains('section-id'))
			return sibling;

		sibling = sibling.previousElementSibling;
	}
}

function setSidebar(link) {
	var currentLink = sidebar.querySelector('.current');

	currentLink.classList.remove('current');

	setTimeout(function() {
		currentLink.blur();
	}, 800);

	link.classList.add('current');
}

/*=============================
=        Scroll To Link       =
=============================*/

var scrollLinks = [].slice.call(document.querySelectorAll('.scroll-link'));

scrollLinks.forEach(function(scrollLink) {
	scrollLink.addEventListener('click', function(e) {
		if(this.tagName == 'A')
			e.preventDefault();

		if(this.parentNode.parentNode == sidebar)
			setSidebar(this);

		scrollToElement(document.querySelector(this.getAttribute('href')));
	});
});

var sectionId = window.location.hash,
	section = sectionId ? document.querySelector(sectionId) : false;

if(section) {
	setTimeout(function() {
		scrollToElement(section);
	}, 300);

	if(section.parentNode.classList.contains('accordion')) {
		setTimeout(function() {
			Velocity(section.querySelector('.answer'), 'slideDown', {duration: 250});

			var button = section.querySelector('button');

			button.classList.add('open');

			button.setAttribute('aria-expanded', 'true');
		}, 1200);
	}
}

var sectionSelect = document.getElementById('section-select');

if(sectionSelect)
	sectionSelect.addEventListener('change', function() {
		scrollToElement(document.getElementById(this.value));
	});

/*=============================
=         Element Link        =
=============================*/

var links = [].slice.call(document.querySelectorAll('.link'));

links.forEach(function(link) {
	link.addEventListener('click', function(e) {
		if(e.target.tagName !== 'A' && this.hasAttribute('data-href')) {
			var href = this.dataset.href;

			if(href.indexOf(location.host) == -1)
				window.open(href);
			else
				window.location.href = href;
		}
	});
});

/*=============================
=          Accordion          =
=============================*/

var accordions = [].slice.call(document.querySelectorAll('ul.accordion button'));

accordions.forEach(function(accordion) {
	accordion.addEventListener('click', function() {
		var answer = this.nextSibling,
			animation = window.getComputedStyle(answer).display == 'block' ? 'slideUp' : 'slideDown';

		closeAccordion(this);

		Velocity(answer, animation, {duration: 250});

		this.classList.toggle('open');

		this.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

		// setTimeout(function() {
		// 	scrollToElement(this.parentNode);
		// }, 250);
	});
});

function closeAccordion(el) {
	var openAccordion = el.parentElement.parentElement.querySelector('.open');

	if(openAccordion && openAccordion !== el) {
		Velocity(openAccordion.nextSibling, 'slideUp', {duration: 250});

		openAccordion.classList.toggle('open');
	}
}

[].slice.call(document.querySelectorAll('.accordion-tags button')).forEach(function(filterButton) {
	filterButton.addEventListener('click', function() {
		var current = this.parentNode.parentNode.querySelector('button[aria-checked="true"]');

		if(this !== current) {
			current.setAttribute('aria-checked', 'false');
			current.setAttribute('tabindex', '-1');

			this.setAttribute('aria-checked', 'true');
			this.removeAttribute('tabindex');

			[].slice.call(document.querySelectorAll('ul.accordion li')).forEach(function(accordion) {
				if(accordion.getAttribute('aria-labelledby').includes(current.id))
					accordion.classList.add('hidden');
				if(accordion.getAttribute('aria-labelledby').includes(filterButton.id))
					accordion.classList.remove('hidden');
			})
		}
	});
});

/*=============================
=       Google Translate      =
=============================*/

var languages = [].slice.call(document.querySelectorAll('.language-picker-container a'));

languages.forEach(function(language) {
	language.addEventListener('click', function(e) {
		e.preventDefault();

		var lang = this.getAttribute('hreflang');

		if(Cookie.get('language') !== lang) {
			googTransHandle(false, lang);

			var splitDomain = location.host.split('.');

			if(splitDomain.length >= 2)
				googTransHandle(location.host.replace(splitDomain[0]+(splitDomain.length == 2 ? splitDomain[1] : ''), ''), lang);

			window.location.reload();
		}
	});
});

function googTransHandle(domain, lang) {
	if(!domain) {
		if(typeof Cookie.get('googtrans')!=='undefined') {
			Cookie.remove('language');
			Cookie.remove('googtrans');
		}
		if(lang!=='en') {
			Cookie.set('language', lang);
			Cookie.set('googtrans', '/en/'+lang);
		} 
	} else {
		if(typeof Cookie.get('googtrans', {domain: domain})!=='undefined') {
			Cookie.remove('language', {domain: domain});
			Cookie.remove('googtrans', {domain: domain});
		}
		if(lang!=='en') {
			Cookie.set('language', lang, {domain: domain});
			Cookie.set('googtrans', '/en/'+lang, {domain: domain});
		}
	}
}

/*=============================
=             Modal           =
=============================*/

var modals = [].slice.call(document.querySelectorAll('div[role="dialog"]:not(.gm-style-iw)')),
	ieModal = document.getElementById('ie-modal');

modals.forEach(function(modal) {
	modal.addEventListener('click', function(e) {
		if(e.target == modal.querySelector('.close-modal') || !modal.querySelector('.content').contains(e.target))
			closeModal();
	});
});

function closeModal() {
	modals.forEach(function(modal) {
		if(window.getComputedStyle(modal).display == 'block')
			Velocity(modal, {opacity: [0,1]}, {duration: 300, display: 'none'});

		// if(modal == videoModal) {
		// 	setTimeout(function() {
		// 		videoIframe.src = 'about:blank';
		// 		skipLinkToggleDisplay(false);
		// 		setFocus(false, false);
		// 	}, 300);
		// }
	});
}

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		closeModal();
});

if(ieModal) {
	ieModal.querySelector('.close-modal').focus();
	skipLinkToggleDisplay(true);
	setFocus(true, false);
}

/*=============================
=            Search           =
=============================*/

[].slice.call(document.querySelectorAll('form[id*="site-search"]')).forEach(function(search) {
	search.addEventListener('submit', function(e) {
		e.preventDefault();

		var input = this.querySelector('input');

		if(input.value !== '')
			window.location.href = '/search?q='+input.value+'#search-results';
		else
			input.classList.add('error');
	});
});

var desktopSearchForm = document.getElementById('desktop-site-search'),
	desktopSearchInput = desktopSearchForm.querySelector('input');

desktopSearchForm.querySelector('button').addEventListener('click', function() {
	if(desktopSearchForm.classList.contains('open') && desktopSearchInput.value === '') {
		desktopSearchForm.classList.remove('open');
		desktopSearchInput.setAttribute('aria-hidden', 'true');
		desktopSearchInput.setAttribute('tabindex', '-1');
	}
	else {
		desktopSearchForm.classList.add('open');
		desktopSearchInput.setAttribute('aria-hidden', 'false');
		desktopSearchInput.removeAttribute('tabindex');
		desktopSearchInput.focus();
	}
});

/*=============================
=             Video           =
=============================*/

[].slice.call(document.querySelectorAll('.video-container button')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {
		var parent = this.parentNode.parentNode,
			thumbnail = parent.querySelector('.thumbnail'),
			video = parent.querySelector('figure.video > *:first-child');

		if(thumbnail)
			Velocity(thumbnail, {opacity: [0,1]}, {duration: 150, display: 'none'});

		playVideo(video);
	});
});

function playVideo(video) {
	video.src = video.dataset.src;

	if(video.tagName === 'VIDEO')
		video.autoplay = true;
}

function resetVideo(video) {
	var src = video.src;

	video.src = src.replace('?autoplay=1&rel=0', '');
}

/*=============================
=            Slider           =
=============================*/

window.slider = function slider(section) {
    var slider = section ? section.querySelector('.slider') : false;

    if(slider) {
    	var isStatistics = section.classList.contains('statistics'),
	    	isImageCards = section.classList.contains('cards'),
	    	posX1 = 0,
	        posX2 = 0,
	        posInitial,
	        posFinal,
	        threshold = 100,
			slides = slider.querySelectorAll('.slide'),
	        slidesLength = slides.length,
	        firstSlide = slides[0],
	        initialSlideSize = firstSlide.offsetWidth + Math.abs(slides[1].getBoundingClientRect().left - firstSlide.getBoundingClientRect().right),
	        lastSlide = slides[slidesLength - 1],
	        cloneFirst = firstSlide.cloneNode(true),
	        cloneLast = lastSlide.cloneNode(true),
	        index = 0,
	        allowShift = true,
	        isHero = section.id == 'hero';

		if(isHero) {
			var heroSliderInterval,
	            autoSlideHero = function() {
		    		shiftSlide(1);
		    	};

		    // Slider Auto Scroll
		    heroSliderInterval = setInterval(autoSlideHero, 5000);
		}
	  
	    // Clone first and last slide
	    slider.appendChild(cloneFirst);
	    slider.insertBefore(cloneLast, firstSlide);

	    if(isImageCards)
	    	firstSlide.classList.add('current');

	    if(section.classList.contains('statistics') && section.classList.contains('is-slider')) {
	    	slider.appendChild(slides[1].cloneNode(true));
	    	slider.appendChild(slides[2].cloneNode(true));
	    	slider.appendChild(slides[3].cloneNode(true));
	    }

	    // Mouse events
	    slider.onmousedown = dragStart;

	    // Touch events
	    slider.addEventListener('touchstart', dragStart, {passive: true});
	    slider.addEventListener('touchend', dragEnd, {passive: true});
	    slider.addEventListener('touchmove', dragAction, {passive: true});

	    // Bullet click events
        var sliderButtonsContainer = section.querySelector('.slider-buttons'),
			sliderButtons = sliderButtonsContainer ? sliderButtonsContainer.querySelectorAll('button') : [];

		[].slice.call(sliderButtons).forEach(function(button, buttonIndex) {
			button.addEventListener('click', function() {
				if(isHero)
					clearInterval(heroSliderInterval);

				shiftSlide(buttonIndex - index);
			});
		});

	    // Next/Prev click events
        var nextPrevButtons = section.querySelectorAll('button.next, button.prev');

		[].slice.call(nextPrevButtons).forEach(function(button) {
			button.addEventListener('click', function() {
				shiftSlide(button.classList.contains('next') ? 1 : -1);
			});
		});

	    // Transition events
	    slider.addEventListener('transitionend', checkIndex);

	    function slideSize() {
	    	return isImageCards && checkWidth(768) ? initialSlideSize : (firstSlide.offsetWidth + Math.abs(slides[1].getBoundingClientRect().left - firstSlide.getBoundingClientRect().right));
	    }
	  
	    function dragStart(e) {
	        e = e || window.event;
	        // e.preventDefault();

			if(isHero)
				clearInterval(heroSliderInterval);

	        posInitial = slider.offsetLeft;

	        if(e.type == 'touchstart') {
	            posX1 = e.touches[0].clientX;
	        } else {
	            posX1 = e.clientX;
	            document.onmouseup = dragEnd;
	            document.onmousemove = dragAction;
	        }
	    }

	    function dragAction(e) {
	        e = e || window.event;

	        if(e.type == 'touchmove') {
	            posX2 = posX1 - e.touches[0].clientX;
	            posX1 = e.touches[0].clientX;
	        } else {
	            posX2 = posX1 - e.clientX;
	            posX1 = e.clientX;
	        }

	        slider.style.left = (slider.offsetLeft - posX2) + 'px';
	    }
	  
	    function dragEnd(e) {
	        posFinal = slider.offsetLeft;

	        if(posFinal - posInitial < -threshold)
	            shiftSlide(1, 'drag');
	        else if(posFinal - posInitial > threshold)
	            shiftSlide(-1, 'drag');
	        else
	            slider.style.left = (posInitial) + 'px';

	        document.onmouseup = null;
	        document.onmousemove = null;
	    }
	  
		function shiftSlide(dir, action) {
			slider.classList.add('shifting');

			if(allowShift) {
				if(!action)
					posInitial = slider.offsetLeft;

				slider.style.left = (posInitial - (slideSize() * dir)) + 'px';

				index = index+dir;
			}

			allowShift = false;
		}

		function checkIndex() {
			slider.classList.remove('shifting');

			if(index == -1) {
				slider.style.left = getSlidePosition(slidesLength);
				index = slidesLength - 1;
			}

			if(index == slidesLength) {
				slider.style.left = getSlidePosition(1);
				index = 0;
			}

			if(sliderButtonsContainer) {
				sliderButtonsContainer.querySelector('.current').blur();
				sliderButtonsContainer.querySelector('.current').classList.remove('current');
				sliderButtons[index].classList.add('current');
			}

			if(isImageCards) {
				slider.querySelector('.current').classList.remove('current');
				slides[index].classList.add('current');
			}

			allowShift = true;
		}

		function getSlidePosition(slideIndex) {
			return ((isImageCards || (isStatistics && checkWidth(768)) ? ((window.innerWidth - firstSlide.offsetWidth) / 2) : 0) - (slideIndex * slideSize())) + 'px';
		}

		// Window Resize
		window.addEventListener('resize', adjustSlider);
		window.addEventListener('orientationchange', adjustSlider);

		function adjustSlider() {
			slider.style.left = getSlidePosition(index+1);
		}
    }
};

var sliderSections = ['#hero', 'section.text_slider', 'section.statistics', 'section.testimonials.is-slider', 'section.cards', 'section.events.is-slider'];

sliderSections.forEach(function(section) {
	slider(document.querySelector(section));
});

/*=============================
=          Statistics         =
=============================*/

[].slice.call(document.querySelectorAll('.statistics-container')).forEach(function(statisticsContainer) {
	var statisticsAnimation = new Waypoint({
		element: statisticsContainer,
		handler: function(direction) {
			[].slice.call(statisticsContainer.querySelectorAll('.stat')).forEach(function(stat) {
				animateCountUp(stat);
			});

			this.destroy();
		},
		offset: '85%'
	});
});

// How long you want the animation to take, in ms
const animationDuration = 750;
// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
const frameDuration = 2000 / 60;
// Use that to calculate how many frames we need to complete the animation
const totalFrames = Math.round(animationDuration / frameDuration);
// An ease-out function that slows the count as it progresses
const easeOutQuad = t => t * (2 - t);

// The animation function, which takes an Element
const animateCountUp = el => {
	let frame = 0;
	let num = el.querySelector('.number span.num');

	const countTo = parseInt(num.innerHTML, 10);
	// Start the animation running 60 times per second
	const counter = setInterval(() => {
		frame++;
		// Calculate our progress as a value between 0 and 1
		// Pass that value to our easing function to get our
		// progress on a curve
		const progress = easeOutQuad(frame / totalFrames);
		// Use the progress value to calculate the current count
		const currentCount = Math.round(countTo * progress);

		// If the current count has changed, update the element
		if(parseInt(num.innerHTML, 10) !== currentCount)
			num.innerHTML = currentCount.toLocaleString('en-US');

		// If we’ve reached our last frame, stop the animation
		if(frame === totalFrames) {
			clearInterval(counter);
			el.classList.add('done');
		}
	}, frameDuration);
};

/*=============================
=              Tabs           =
=============================*/

[].slice.call(document.querySelectorAll('.tabs-list button, .tab-panel .close-modal')).forEach(function(tabButton) {
	tabButton.addEventListener('click', function() {
		var isCloseTab = this.classList.contains('close-modal'),
			tabPanel = isCloseTab ? this.parentNode : document.getElementById(this.getAttribute('aria-controls')),
			current = this.parentNode.parentNode.querySelector('button[aria-selected="true"]');

		if(this !== current) {
			if(current) {
				current.setAttribute('aria-selected', 'false');
				current.setAttribute('tabindex', '-1');
				document.getElementById(current.getAttribute('aria-controls')).classList.add('hidden');
			}

			if(!isCloseTab) {
				this.setAttribute('aria-selected', 'true');
				this.removeAttribute('tabindex');
				tabPanel.classList.remove('hidden');
				tabPanel.focus({preventScroll:true});
			}

			if(checkWidth(769)) {
				if(isCloseTab)
					closeTab(tabPanel);
				else {
					body.classList.add('tab-modal-open');

					Velocity(tabPanel, {opacity: [1,0]}, {duration: 300, display: 'block'});
				}
			}
		}
	});
});

body.addEventListener('click', function(e) {
	var el = e.target,
		openTab = document.querySelector('.tab-panel:not(.hidden)');

	if(body.classList.contains('tab-modal-open') && el.getAttribute('role') != 'tab' && (el == openTab.querySelector('.close-modal') || !openTab.contains(el)))
		closeTab(openTab);
});

function closeTab(tab) {
	body.classList.remove('tab-modal-open');

	Velocity(tab, {opacity: [0,1]}, {duration: 300, display: 'none'});
}

/*=============================
=          Google Map         =
=============================*/

var mapContainer = document.querySelector('.map-container');

if(mapContainer) {
	scriptWaypoint(mapContainer, 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB9x1oT9Ttazg1gZI375eYz5fZkNryHIEk&callback=initMap', '150%');

	window.initMap = initMap;

	function initMap() {
		var coordinates = JSON.parse('['+mapContainer.dataset.coordinates+']'),
			latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
			mapOptions = {
				zoom: 13,
				streetViewControl: false, // hide the yellow Street View pegman
				scaleControl: true, // allow users to zoom the Google Map
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				scrollwheel: false,
				disableDefaultUI: true,
				center: latLng,
				styles: mapStyles
			},
			map = new google.maps.Map(mapContainer, mapOptions);

		if(body.classList.contains('location'))
			var marker = new google.maps.Marker({
					map: map,
					position: latLng,
					draggable: false,
					animation: google.maps.Animation.DROP
				});
	}
}

/*=============================
=      Load 3rd Party JS      =
=============================*/

// window.addEventListener('load', function() {
// 	var js = [
// 		''
// 	];

// 	js.forEach(function(src) {
// 		addJS(src);
// 	});
// });


/*=============================
=  Translation Button Toggle   =
=============================*/

var translateButton = [].slice.call(document.querySelectorAll('.dropBtn'));

document.addEventListener('DOMContentLoaded', function() {
	const showBtn = document.getElementById('langButton');
	
	const hiddenDiv = document.getElementById('langPicker');

	hiddenDiv.style.display === 'none';

	showBtn.addEventListener('click', function () {
		hiddenDiv.style.display = hiddenDiv.style.display === 'none' ? 'grid' : 'none';
		hiddenDiv.classList.toggle('show');
		showBtn.classList.toggle('clicked');
	});

	document.body.addEventListener('click', function () {
		if(showBtn.classList.contains('clicked')) {
			if(!hiddenDiv.contains(event.target) && event.target !== showBtn && hiddenDiv.style.display == 'grid') {
				hiddenDiv.style.display = hiddenDiv.style.display === 'none' ? 'grid' : 'none';
				hiddenDiv.classList.remove('show');
				showBtn.classList.remove('clicked');
			}
		}
	});
});

/*=============================
=        Cookies Banner       =
=============================*/

function setCookie(name,value,days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

document.getElementById('acceptCookies').addEventListener('click', function(){
	setCookie('gdpr', true, 360);
	document.getElementById('acceptCookies').parentElement.parentElement.classList.add('hidden');
});

var gdprCookie = getCookie('gdpr');
if (gdprCookie) {
	document.getElementById('acceptCookies').parentElement.parentElement.classList.add('hidden');
}